export default function () {
  return {

    fases: {
      data: [],
    },
  };
}
